import React, {useContext} from 'react';
import {InsuranceContext} from "../InsuranceContext";
import TitleInsurance from "../TitleInsurance";
import InsuranceInput from "../InsuranceInput";

function FurtherInformation(props) {
  const helper = useContext(InsuranceContext);
  const setMyData = helper.setMyData
  const myData = helper.myData


  const objectKey = "furtherInfo"
  return (<div>
    <TitleInsurance title={'اطلاعات کلی'}/>
    <div className={'insurance__box border__insurance'}>
      <InsuranceInput
        objectKey={objectKey}
        row={//
          {title: "توضیحات", type: 'textarea', name: 'description', required: true,

          }//
           }

      />
    </div>

  </div>);
}

export default FurtherInformation;